export default {
    inquiryList: [],
    inquiryCount: 0
}